import React from 'react';
import { Link } from 'react-router';
import PropTypes from 'prop-types';
import R from 'ramda';

import _ from 'underscore';
// TODO: confirm we don't need code splitting here
import str from 'underscore.string';
_.str = str;

const getTitle = R.propOr('No Content Title', 'title');
const getSectionTitle = R.propOr('No Course Section Title', 'section_title');

export default class SearchItem extends React.Component {
    static displayName = 'SearchItem';

    static propTypes = {
        result: PropTypes.object,
        stealFocus: PropTypes.bool,
    };

    onFocusRef = el => {
        if (el && this.props.stealFocus) {
            el.children[0].focus();
        }
    };

    renderMaterial() {
        const { result } = this.props;
        let title = getTitle(result);
        let sectionTitle = getSectionTitle(result);

        title = _.str.truncate(title, 30, '');
        sectionTitle = _.str.truncate(sectionTitle, 30, '');

        return (
            <li className="result-material" aria-label="Search result material">
                <p>
                    {title} : {sectionTitle}
                </p>
            </li>
        );
    }

    renderResultLink() {
        const { result } = this.props;
        const contentId = parseInt(result.content.split('/').slice(-2, -1), 10);

        return (
            <li className="result-link" aria-label="Search result">
                <h2 ref={this.onFocusRef}>
                    <Link
                        to={`content-${contentId}/address/${result.page}`}
                        className="js-search-result"
                    >
                        <span className="aural">Go to</span> Page{' '}
                        {result.page_label} of {result.title}
                    </Link>
                </h2>
            </li>
        );
    }

    renderResultSnippet() {
        const result = this.props.result;
        let paragraph;
        if (result.note_text != null) {
            paragraph = <p>{result.note_text}</p>;
        } else {
            const __html = result.highlighted.text[0];
            paragraph = <p dangerouslySetInnerHTML={{ __html }} />;
        }

        return (
            <li className="result-snippet" aria-label="Search result text">
                {paragraph}
            </li>
        );
    }

    render() {
        return (
            <li className="result-item">
                <ul>
                    {this.renderResultLink()}
                    {this.renderResultSnippet()}
                    {this.renderMaterial()}
                </ul>
            </li>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/search/item.jsx